
import { Vue, Prop, Watch } from "vue-property-decorator";
export default class ContinueButton extends Vue {
	@Prop({ default: "" }) isIncomplete: string;
	@Prop({ default: false }) disabled: boolean;
	text: string = "";
}
